module.exports = __webpack_public_path__ + "img/Scroll Group 71.f35dafaf.png";